/**
 * .select-other
 * Register a trigger for the .select-other -> to make the field visible if certain value matches
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */


;(function($) {

    "use strict";

    $(function(){

        var $selector = '[data-select-other]';

        /**
         * Define the method
         * @return string
         */
        var selectOther = function(){
            // Trigger Input Field
            var field = $(this);
            // Extract info from data-* attributes
            // container is the block that needs to become visible
            var container = $(field).data('select-other');
            // no container, return
            if(!container){
                return;
            }
            // Comparison value
            var value = $(field).data('select-other-value') || '';
            // Assuming all the fields in container will become required
            var $fields = $(container).find(':input[data-required]');
            // Toggle visibilty
            if(field.val() == value){
                /* show and require */
                $(container).collapse('show');
                $fields.attr('required', 'required');
            } else {
                /* hide and omit*/
                $(container).collapse('hide');
                $fields.removeAttr('required');
            }
        }

        /**
         * Append method to any input with class .input-trim
         */
        $($selector).change(selectOther);

        /**
         * Append method to any remotely loaded modal
         */
        $('#remote').on('loaded.bs.modal', function (e) {
            // Identify the Modal
            var modal  = $(this);
            // Attach the change action
            modal.find($selector).change(selectOther);
        });
    });

})(window.jQuery);
